module.exports = __webpack_public_path__ + "img/Twist00.93df70e0.jpg";